class ProductGallery extends HTMLElement {
  connectedCallback() {
      this.thumbnails = this.querySelector('[data-thumbnails]');
      this.container = document.querySelector('[data-variant-gallery-container]');
      this.productGalleryOverlay = this.querySelector('.product-gallery-overlay');
      this.videoModal = document.getElementById('videoModal');
      // Reference the product gallery and zoom navigation elements
        const productGallery = document.querySelector('.product-gallery');
        const zoomContainer = document.querySelector('.swiper-zoom-container');
        const zoomButtons = [...document.querySelectorAll('.zoom-navigation button')];

        // Add event listener to handle zoom start
        zoomContainer.addEventListener('zoomstart', () => {
        productGallery.classList.add('zoomed-in'); // Add the zoomed-in class
        });

        // Add event listener to handle zoom end
        zoomContainer.addEventListener('zoomend', () => {
        productGallery.classList.remove('zoomed-in'); // Remove the zoomed-in class
        });

        // Prevent overlay click event from triggering close when interacting with nav buttons
        zoomButtons.forEach(button => {
        button.addEventListener('click', (event) => {
            event.stopPropagation();
        });
        });

      window.addEventListener('load', () => {
          this.init();
          this.container.addEventListener('theme:gallery:reinit', () => {
              this.init();
          });
      });

      this.slides = [...this.querySelectorAll('.gallery-slide')];
      this.slides.forEach(el => el.addEventListener('click', (e) => {
          if (!this.isMobileDevice()) {
              if (this.classList.contains('modal')) {
                  this.toggleSliderArrows(true);
                  this.classList.toggle('zoom-in');
                  if (this.classList.contains('zoom-in')) {
                      this.toggleSliderArrows(false);
                      this.main.zoom.in();
                  } else {
                      this.toggleSliderArrows(false);
                      this.main.zoom.out();
                  }
              } else {
                  this.openModal();
              }
          }
      }));

      this.overlay = [...this.querySelectorAll('.product-gallery-overlay')];
      this.overlay.forEach(el => {
        el.addEventListener('click', (event) => {
          // Close modal only if clicked directly on the overlay (not its children)
          if (event.target === el) {
            this.closeModal();
          }
        });
      });

      this.closeButton = [...this.querySelectorAll('[data-modal-close]')];
      this.closeButton.forEach(el => {
        el.addEventListener('click', (event) => {
          event.stopPropagation(); // Prevent event bubbling
          this.closeModal();
        });
      });

      // Add event listeners to navigation buttons to prevent event bubbling
      const navButtons = [...this.querySelectorAll('.swiper-button-prev, .swiper-button-next')];
      navButtons.forEach(button => {
        button.addEventListener('click', (event) => {
          event.stopPropagation(); // Prevent overlay click event from triggering
        });
      });

  }

  openModal() {
      this.classList.add('modal');
      this.toggleSliderArrows(false);
      this.lockBodyScroll();
      this.showProductGalleryOverlay(); // Show overlay when modal is opened
  }

  closeModal() {
      this.classList.remove('modal');
      this.toggleSliderArrows(true);
      this.unlockBodyScroll();
      this.main.zoom.out();
      this.hideProductGalleryOverlay(); // Hide overlay when modal closes
  }

  init() {
      this.main = new Swiper('[data-main-gallery]', {
          pagination: {
              el: '.swiper-pagination',
              type: 'bullets',
              clickable: true,
              bulletClass: 'swiper-pagination-bullet',
              bulletActiveClass: 'swiper-pagination-bullet-active',
          },
          thumbs: {
              swiper: new Swiper('[data-thumbnails]', {
                  slidesPerView: 'auto',
                  spaceBetween: 10,
                  slideThumbActiveClass: 'swiper-slide-thumb-active',
                  watchSlidesVisibility: true,
                  watchSlidesProgress: true,
                  a11y: { slideRole: 'button' },
              }),
          },
          spaceBetween: 5,
          navigation: true,
          zoom: {
              maxRatio: 3,
              toggle: true // Disable toggle so we can control it ourselves
          },
          allowTouchMove: true,
          navigation: {
              nextEl: '[data-swiper-button-next]',
              prevEl: '[data-swiper-button-prev]',
          }
      });

      const thumbsEl = this.querySelector('[data-thumbnails]');
      if (thumbsEl) {
          thumbsEl.addEventListener('keydown', (e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                  const btn = e.target.closest('button[data-index]');
                  if (btn) {
                      e.preventDefault();
                      this.main.slideTo(parseInt(btn.dataset.index, 10) - 1);
                  }
              }
          });
      }
  }

  showProductGalleryOverlay() {
      if (this.productGalleryOverlay) {
          this.productGalleryOverlay.classList.add('show');
      }
  }

  hideProductGalleryOverlay() {
      if (this.productGalleryOverlay) {
          this.productGalleryOverlay.classList.remove('show');
      }
  }

  toggleSliderArrows(show) {
      if (this.sliderArrows && this.sliderArrows.length > 0) {
          for (let i = 0; i < this.sliderArrows.length; i++) {
              this.sliderArrows[i].style.display = show ? 'block' : 'none';
          }
      }
  }

  lockBodyScroll() {
      this.scrollY = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = `-${this.scrollY}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.overflow = 'hidden';
  }

  unlockBodyScroll() {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.overflow = '';
      window.scrollTo(0, this.scrollY);
  }

  isMobileDevice() {
      return window.innerWidth <= 768;
  }
}

customElements.define('product-gallery', ProductGallery);
